/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoBi {
    angular.module("meevo.plugins.meevoBi", []);
}